import { WAVETABLE_MAX_UNISON } from "./types";

export type UnisonVoiceLayout = {
  /** Normalized seam position −1..+1. */
  t: number;
  detuneCents: number;
  pan: number;
  level: number;
};

/**
 * Unison voice layout around a center (odd N) or virtual seam (even N).
 * Shared by kernel DSP and the authoring visualizer.
 */
export function layoutUnisonVoices(
  voiceCount: number,
  detuneCents: number,
  spread: number,
  edgeDecay: number,
): UnisonVoiceLayout[] {
  const n = Math.min(WAVETABLE_MAX_UNISON, Math.max(1, Math.round(voiceCount)));
  const det = Number.isFinite(detuneCents) ? detuneCents : 0;
  const spr = Math.min(1, Math.max(0, Number.isFinite(spread) ? spread : 0));
  const decay = Math.min(1, Math.max(0, Number.isFinite(edgeDecay) ? edgeDecay : 0));
  const out: UnisonVoiceLayout[] = [];
  for (let i = 0; i < n; i++) {
    const o = i - (n - 1) / 2;
    const t = n === 1 ? 0 : o / ((n - 1) / 2);
    out.push({
      t,
      detuneCents: t * det,
      pan: t * spr,
      level: 1 - Math.abs(t) * decay,
    });
  }
  return out;
}
